var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard" },
    [
      _c(
        "v-container",
        {
          staticClass: "py-0 px-0",
          attrs: { "grid-list-xs": "", "fill-height": "", fluid: "" }
        },
        [
          _c(
            "v-layout",
            { staticClass: "fluid-complete" },
            [
              _c(
                "v-flex",
                [
                  _c(
                    "v-card",
                    { staticClass: "info-box" },
                    [
                      _c(
                        "v-container",
                        { staticClass: "py-3", attrs: { fluid: "" } },
                        [
                          _c(
                            "v-layout",
                            {
                              staticClass: "px-4 py-2",
                              attrs: {
                                "align-center": "",
                                "justify-space-between": "",
                                row: "",
                                "fill-height": ""
                              }
                            },
                            [
                              _c(
                                "v-flex",
                                {
                                  staticClass: "box-dataClient px-2",
                                  attrs: { sm8: "", md7: "", lg8: "" }
                                },
                                [
                                  _vm.isSeller
                                    ? [
                                        _c("p", { staticClass: "mb-0" }, [
                                          _vm._v("Hola,\n"),
                                          _c("strong", [_vm._v("Vendedor")])
                                        ])
                                      ]
                                    : _vm._e(),
                                  _vm.isSupervisor
                                    ? [
                                        _c("p", { staticClass: "mb-0" }, [
                                          _vm._v("Hola,\n"),
                                          _c("strong", [_vm._v("Supervisor")])
                                        ])
                                      ]
                                    : _vm._e(),
                                  _vm.isBoss
                                    ? [
                                        _c("p", { staticClass: "mb-0" }, [
                                          _vm._v("Hola,\n"),
                                          _c("strong", [_vm._v("Jefe")])
                                        ])
                                      ]
                                    : _vm._e(),
                                  _vm.isAdmin
                                    ? [
                                        _c("p", { staticClass: "mb-0" }, [
                                          _vm._v("Hola,\n"),
                                          _c("strong", [
                                            _vm._v("Administrador")
                                          ])
                                        ])
                                      ]
                                    : _vm._e(),
                                  _c("h1", [
                                    _vm.notificationCount > 0
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "on-hold-notification"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.notificationCount > 99
                                                  ? "+99"
                                                  : _vm.notificationCount
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "label",
                                      {
                                        style: {
                                          "padding-left":
                                            _vm.notificationCount > 0
                                              ? "30px"
                                              : "0"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.user.firstName) + "   "
                                        )
                                      ]
                                    ),
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.user.lastName) + " ")
                                    ])
                                  ]),
                                  _c("p", { staticClass: "mb-0" }, [
                                    _vm._v(_vm._s(_vm.today))
                                  ])
                                ],
                                2
                              ),
                              _vm.isSupervisor || _vm.isSeller
                                ? _c(
                                    "v-btn",
                                    {
                                      staticClass:
                                        "btn-principal box-btn-movil",
                                      attrs: { large: "" },
                                      on: { click: _vm.startAffiliation }
                                    },
                                    [
                                      _c("p", { staticClass: "mb-0 mt-2" }, [
                                        _vm._v("Nueva Afiliación")
                                      ]),
                                      _c("v-icon", [
                                        _vm._v(
                                          "icon-ic-nueva-afiliacion-blanco"
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("p"),
                  _c(
                    "v-container",
                    {
                      staticClass: "graphic container__dashboard",
                      attrs: { "grid-list-xs": "" }
                    },
                    [
                      _c("no-ssr"),
                      _c(
                        "div",
                        { staticClass: "mt-5 graphic-box" },
                        [
                          _c("affiliations-process", {
                            on: { leaving: _vm.leavingPage }
                          }),
                          _c("affiliations-worked", {
                            staticClass: "mt-4",
                            on: { leaving: _vm.leavingPage }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("loader", {
            ref: "loaderModal",
            attrs: { text: "Cargando información" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-363a5543", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-363a5543","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/dashboard/index.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-363a5543","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/dashboard/index.vue
// module chunks = 5